import { merge } from "lodash";

import common from "./common";

export default {
  propertyWanted: {
    title: "Property Wanted",
    table: {
      column: {
        type: "Type",
        groupType: "Property Group Type",
        location: "Location",
        budget: "Budget",
        bedBath: "Bedroom / Bathroom",
        date: "Date",
      },
    },
    sort: {
      budgetDesc: "Budget (highest - lowest)",
      budgetAsc: "Budget (lowest - highest)",
      dateDesc: "Date (newest - lowest)",
      dateAsc: "Date (lowest - newest)",
    },
    details: {
      interested: "Interested",
      firstState: "First Choice State",
      firstLocation: "First Choice Location",
      secondState: "Second Choice State",
      secondLocation: "Second Choice Location",
      thirdState: "Third Choice State",
      thirdLocation: "Third Choice Location",
      groupType: "Property Group Type",
      type: "Property Type",
      room: "No. of Rooms",
      bath: "No. of Bathrooms",
      minBudget: "Min. Budget",
      maxBudget: "Max. Budget",
      remarks: "Remarks",
    },
    ...merge(common, {}),
  },
};
